import { getFetch } from '@/plugins/http'
import { postFetch } from '@/plugins/http'

// const baseHost = '//127.0.0.1'
const baseHost = `${process.env.VUE_APP_HOST}/hike-boot`

export default {
  /**
   * 日程安排-新增
   * @param {String}} schedule_time title  content
   */
  addEvent(params = {}, config) {
    return postFetch(`${baseHost}/common/api/10-insertSchedule/user_homepage`, params, config)
  },
  /**
   * 日程安排-删除
   * @param {String}}
   */
  delEvent(params = {}, config) {
    return postFetch(`${baseHost}/common/api/90-delUserSchedule/user_homepage`, params, config)
  },
  /**
   * 日程安排-完成
   * @param {String}}
   */
  hasDoneEvent(params = {}, config) {
    return postFetch(`${baseHost}/common/api/20-endUserSchedule/user_homepage`, params, config)
  },
  /**
   * 日程安排-列表
   * @param {String}}
   */
  getEventList(params = {}, config) {
    return getFetch(
      `${baseHost}/common/api/34-getUserSchedulePageList/user_homepage`,
      params,
      config
    )
  },
  /**
   * 日程安排-编辑
   * @param {String}}
   */
  updateEvent(params = {}, config) {
    return postFetch(`${baseHost}/common/api/20-updateSchedule/user_homepage`, params, config)
  },
  /**
   * 快捷应用-列表
   */
  getQuicklyApp(params = {}, config) {
    return getFetch(
      `${baseHost}/common/api/34-getApplicationHomepagePageList/user_homepage`,
      params,
      config
    )
  },
  /**
   * 快捷应用-列表
   */
  getRecentWatchList(params = {}, config) {
    return getFetch(
      `${baseHost}/common/api/34-getUserRecentCheckPageList/user_homepage`,
      params,
      config
    )
  },
  /**
   * 我的会议-会议列表(天)
   */
  getMyMeeting(params, config) {
    return getFetch(
      `${baseHost}/common/api/33-getUserConferenceListByDay/user_homepage`,
      params,
      config
    )
  },
  /**
   * 我的会议-创建会议
   */
  creatMyMeeting(params, config) {
    return postFetch(`${baseHost}/txhy/saveMeeting`, params, config)
  },
  /**
   * 我的会议-创建会议-跳转授权页面
   */
  jumpAuthorizePage(params, config) {
    return getFetch(`${baseHost}/txhy/auth/getAuthorize`, params, config)
  },
  /**
   * 我的会议-已邀请老师列表
   */
  getInvitedTeacherList(params, config) {
    return getFetch(`${baseHost}/common/api/33-getMeetingUserTeacher/myMeeting`, params, config)
  },
  /**
   * 我的会议-选择老师列表
   */
  getSelectList(params, config) {
    return getFetch(`${baseHost}/common/api/34-select_list/myMeeting`, params, config)
  },
  /**
   * 我的会议-邀请老师
   */
  inviteTeacherJoin(params, config) {
    return postFetch(`${baseHost}/txhy/meetingInvite`, params, config)
  },
  /**
   * 日程安排-查询列表(天)
   */
  getMyPlanning(params, config) {
    return getFetch(
      `${baseHost}/common/api/33-getUserScheduleListByDay/user_homepage`,
      params,
      config
    )
  },
  /**
   * 查询学校课程表(天)
   */
  getClassScheduleByDay(params, config) {
    return getFetch(`${baseHost}/schoolCourse/querySchoolCourseScheduleDay`, params, config)
  },
  /**
   * 查询学校课程表(周)
   */
  getClassScheduleByWeek(params, config) {
    return getFetch(`${baseHost}/schoolCourse/querySchoolCourseScheduleWeek`, params, config)
  },
  /**
   * 查询学校课程表(日历红点)
   */
  getClassScheduleByMonth(params, config) {
    return getFetch(`${baseHost}/schoolCourse/querySchoolCourseCalendar`, params, config)
  },
  /**
   * 个人基本信息
   */
  getHomepageUserInfo(params, config) {
    return getFetch(`${baseHost}/common/api/32-getUserInfo/user_homepage`, params, config)
  },
  /**
   * 我的会议列表
   */
  getMyMeetingList(params, config) {
    return getFetch(`${baseHost}/txhy/getMyMeetingPageList`, params, config)
  },
  /**
   * 会议详情
   */
  getMeetingDetail(params, config) {
    return getFetch(`${baseHost}/txhy/getMyMeetingInfo`, params, config)
  },
  /**
   * 我的会议-修改会议
   */
  updateMyMeeting(params, config) {
    return postFetch(`${baseHost}/txhy/updateMeeting`, params, config)
  },
  /**
   * 删除会议
   */
  deleteMyMeeting(params, config) {
    return postFetch(`${baseHost}/txhy/delMeeting`, params, config)
  }
}
